export const DR_PHOTO = "/assets/dr-shihab-romeed.png";
export const SDL_LOGO = "/assets/specialist-dental-london.png";
export const LDA_LOGO = "/assets/london-dental-academy.png";
export const NAV_LOGO = "/assets/shihab-romeed-logo.png";
